exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#modal-detalle___BV_modal_header_{padding:0!important;border-bottom:none!important}", ""]);

// exports
